import { helpers } from '@vuelidate/validators'

const isNumberInRange = (value: string, min: number, max: number) => {
  const num = Number.parseInt(value)
  if (Number.isNaN(num)) return false
  if (num < min || num > max) return false
  return true
}

const ipv4Regex = new RegExp(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})(:(\d{1,5}))?$/)
export const validIPv4 = (value: string) => {
  const matchResult = value.match(ipv4Regex)
  if (matchResult === null) return false
  if (!isNumberInRange(matchResult[1], 1, 255)) return false
  if (!isNumberInRange(matchResult[2], 0, 255)) return false
  if (!isNumberInRange(matchResult[3], 0, 255)) return false
  if (!isNumberInRange(matchResult[4], 0, 255)) return false

  const portStr = matchResult[6]
  if (portStr === undefined) return true
  if (!isNumberInRange(portStr, 1, 65535)) return false
  return true
}

// Note: Checks for pattern: "[<IPv6>]:<port>" (port is optional)
// Based on: https://stackoverflow.com/a/17871737
/* eslint-disable max-len */
const ipv6Regex = new RegExp(/^\[(([\dA-Fa-f]{1,4}:){7}[\dA-Fa-f]{1,4}|([\dA-Fa-f]{1,4}:){1,7}:|([\dA-Fa-f]{1,4}:){1,6}:[\dA-Fa-f]{1,4}|([\dA-Fa-f]{1,4}:){1,5}(:[\dA-Fa-f]{1,4}){1,2}|([\dA-Fa-f]{1,4}:){1,4}(:[\dA-Fa-f]{1,4}){1,3}|([\dA-Fa-f]{1,4}:){1,3}(:[\dA-Fa-f]{1,4}){1,4}|([\dA-Fa-f]{1,4}:){1,2}(:[\dA-Fa-f]{1,4}){1,5}|[\dA-Fa-f]{1,4}:((:[\dA-Fa-f]{1,4}){1,6})|:((:[\dA-Fa-f]{1,4}){1,7}|:)|fe80:(:[\dA-Fa-f]{0,4}){0,4}%[\dA-Za-z]+|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)\.){3}(25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)|([\dA-Fa-f]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)\.){3}(25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d))](:(\d{1,5}))?$/)
/* eslint-enable max-len */
export const validIPv6 = (value: string) => {
  const matchResult = value.match(ipv6Regex)
  if (matchResult === null) return false
  const portStr = matchResult[matchResult.length-1]
  if (portStr === undefined) return true
  if (!isNumberInRange(portStr, 1, 65535)) return false
  return true
}

// TODO: Support Single word domain names (e.g. "localhost")
// Based on: https://stackoverflow.com/a/62917037
const hostRegex = new RegExp(/^([\dA-Za-z]+(-[\dA-Za-z]+)*\.)+[A-Za-z]{2,}(:(\d{1,5}))?$/)
export const validHost = (value: string) => {
  const matchResult = value.match(hostRegex)
  if (matchResult === null) return false
  const portStr = matchResult[matchResult.length-1]
  if (portStr === undefined) return true
  if (!isNumberInRange(portStr, 1, 65535)) return false
  return true
}

export const validDomain = (value: string) => {
  return !helpers.req(value) || validIPv4(value) || validIPv6(value) || validHost(value)
}
